(() => {
  const ITEM_SELECTOR = '.product-load-item';
  const VISIBLE_CLASS = 'product-load-item--visible';
  const PAGE_SELECTOR = '.product-page-load';
  const PAGE_READY_CLASS = 'product-page-load--ready';

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const revealItems = (root = document) => {
    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR)).filter(
      (el) => !el.classList.contains(VISIBLE_CLASS)
    );

    if (items.length === 0) return;

    if (prefersReducedMotion()) {
      items.forEach((el) => el.classList.add(VISIBLE_CLASS));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const siblings = Array.from(
            el.parentElement?.querySelectorAll(ITEM_SELECTOR) || [el]
          );
          const order = Math.max(0, siblings.indexOf(el));
          el.style.setProperty('--product-load-order', String(order % 12));
          requestAnimationFrame(() => el.classList.add(VISIBLE_CLASS));
          obs.unobserve(el);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    items.forEach((el) => observer.observe(el));
  };

  const revealProductPage = (root = document) => {
    root.querySelectorAll(PAGE_SELECTOR).forEach((page) => {
      if (page.classList.contains(PAGE_READY_CLASS)) return;
      if (prefersReducedMotion()) {
        page.classList.add(PAGE_READY_CLASS);
        return;
      }
      requestAnimationFrame(() => {
        page.classList.add(PAGE_READY_CLASS);
      });
    });
  };

  const run = (root = document) => {
    revealProductPage(root);
    revealItems(root);
  };

  const boot = () => {
    run(document);

    // Related products / recommendations load asynchronously
    document.querySelectorAll('product-recommendations').forEach((node) => {
      const mo = new MutationObserver(() => run(node));
      mo.observe(node, { childList: true, subtree: true });
    });

    // Collection filters / pagination section reloads
    document.addEventListener('shopify:section:load', (event) => {
      run(event.target);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
